// This is a placeholder for the cricket API service// In a real implementation, you'd need to set up a proxy server to call the Cricbuzz API// since it doesn't provide official public APIs with CORS support// This is a mock implementation that returns fake cricket match data
// In a real implementation, you'd connect to an actual cricket API

// Match types with logos
export const MATCH_TYPES = {
  T20: {
    name: 'T20',
    logo: 'https://www.cricbuzz.com/images/cbz-resources/cbz-ipl-resources/images/ipl-logo.png' // A T20 logo
  },
  ODI: {
    name: 'ODI',
    logo: 'https://upload.wikimedia.org/wikipedia/en/thumb/8/8d/Cricket_World_Cup_2023_logo.svg/220px-Cricket_World_Cup_2023_logo.svg.png' // ODI logo
  },
  TEST: {
    name: 'Test',
    logo: 'https://upload.wikimedia.org/wikipedia/en/thumb/e/ef/World_Test_Championship_Logo.svg/200px-World_Test_Championship_Logo.svg.png' // Test cricket logo
  },
  IPL: {
    name: 'IPL',
    logo: 'https://upload.wikimedia.org/wikipedia/en/thumb/8/84/Indian_Premier_League_Official_Logo.svg/240px-Indian_Premier_League_Official_Logo.svg.png' // IPL logo
  }
};

// Mock data for IPL matches
const IPL_MATCHES = [
  {
    id: 'ipl1',
    teams: ['Mumbai Indians', 'Chennai Super Kings'],
    venue: 'Wankhede Stadium, Mumbai',
    status: 'Live',
    matchType: 'IPL',
    score: {
      team1: '145/6',
      team2: '98/3'
    }
  },
  {
    id: 'ipl2',
    teams: ['Royal Challengers Bangalore', 'Delhi Capitals'],
    venue: 'M. Chinnaswamy Stadium, Bangalore',
    status: 'Live',
    matchType: 'IPL',
    score: {
      team1: '187/5',
      team2: '120/4'
    }
  },
  {
    id: 'ipl3',
    teams: ['Kolkata Knight Riders', 'Rajasthan Royals'],
    venue: 'Eden Gardens, Kolkata',
    matchType: 'IPL',
    startTime: new Date(Date.now() + 86400000).toISOString() // Tomorrow
  },
  {
    id: 'ipl4',
    teams: ['Sunrisers Hyderabad', 'Punjab Kings'],
    venue: 'Rajiv Gandhi Stadium, Hyderabad',
    matchType: 'IPL',
    startTime: new Date(Date.now() + 172800000).toISOString() // Day after tomorrow
  },
  {
    id: 'ipl5',
    teams: ['Gujarat Titans', 'Lucknow Super Giants'],
    venue: 'Narendra Modi Stadium, Ahmedabad',
    matchType: 'IPL',
    startTime: new Date(Date.now() + 259200000).toISOString() // 3 days from now
  },
  {
    id: 'ipl6',
    teams: ['Chennai Super Kings', 'Delhi Capitals'],
    venue: 'M. A. Chidambaram Stadium, Chennai',
    matchType: 'IPL',
    startTime: new Date(Date.now() + 345600000).toISOString() // 4 days from now
  }
];

// Mock data for ODI matches
const ODI_MATCHES = [
  {
    id: 'odi1',
    teams: ['India', 'Australia'],
    venue: 'Melbourne Cricket Ground',
    status: 'Live',
    matchType: 'ODI',
    score: {
      team1: '245/6',
      team2: '180/4'
    }
  },
  {
    id: 'odi2',
    teams: ['England', 'South Africa'],
    venue: 'Lord\'s Cricket Ground',
    matchType: 'ODI',
    startTime: new Date(Date.now() + 86400000).toISOString() // Tomorrow
  },
  {
    id: 'odi3',
    teams: ['New Zealand', 'West Indies'],
    venue: 'Eden Park, Auckland',
    matchType: 'ODI',
    startTime: new Date(Date.now() + 172800000).toISOString() // Day after tomorrow
  },
  {
    id: 'odi4',
    teams: ['Pakistan', 'Sri Lanka'],
    venue: 'National Stadium, Karachi',
    matchType: 'ODI',
    startTime: new Date(Date.now() + 259200000).toISOString() // 3 days from now
  },
  {
    id: 'odi5',
    teams: ['Bangladesh', 'Zimbabwe'],
    venue: 'Shere Bangla National Stadium, Dhaka',
    matchType: 'ODI',
    startTime: new Date(Date.now() + 345600000).toISOString() // 4 days from now
  },
  {
    id: 'odi6',
    teams: ['Afghanistan', 'Ireland'],
    venue: 'Sharjah Cricket Stadium',
    matchType: 'ODI',
    startTime: new Date(Date.now() + 432000000).toISOString() // 5 days from now
  }
];

// Mock data for TEST matches
const TEST_MATCHES = [
  {
    id: 'test1',
    teams: ['India', 'England'],
    venue: 'Narendra Modi Stadium, Ahmedabad',
    status: 'Live',
    matchType: 'TEST',
    score: {
      team1: '320/8',
      team2: '150/2'
    }
  },
  {
    id: 'test2',
    teams: ['Australia', 'New Zealand'],
    venue: 'Sydney Cricket Ground',
    matchType: 'TEST',
    startTime: new Date(Date.now() + 86400000).toISOString() // Tomorrow
  },
  {
    id: 'test3',
    teams: ['South Africa', 'Pakistan'],
    venue: 'Newlands, Cape Town',
    matchType: 'TEST',
    startTime: new Date(Date.now() + 172800000).toISOString() // Day after tomorrow
  },
  {
    id: 'test4',
    teams: ['West Indies', 'Sri Lanka'],
    venue: 'Kensington Oval, Bridgetown',
    matchType: 'TEST',
    startTime: new Date(Date.now() + 259200000).toISOString() // 3 days from now
  },
  {
    id: 'test5',
    teams: ['Bangladesh', 'Zimbabwe'],
    venue: 'Shere Bangla National Stadium, Dhaka',
    matchType: 'TEST',
    startTime: new Date(Date.now() + 345600000).toISOString() // 4 days from now
  },
  {
    id: 'test6',
    teams: ['Afghanistan', 'Ireland'],
    venue: 'Greater Noida Sports Complex Ground',
    matchType: 'TEST',
    startTime: new Date(Date.now() + 432000000).toISOString() // 5 days from now
  }
];

/**
 * Get current cricket matches
 * @returns {Promise<Array>} - Array of matches
 */
export const getCurrentMatches = async () => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 500));
  
  // Return all live matches from all categories
  return [
    ...IPL_MATCHES.filter(match => match.status === 'Live'),
    ...ODI_MATCHES.filter(match => match.status === 'Live'),
    ...TEST_MATCHES.filter(match => match.status === 'Live')
  ];
};

/**
 * Get upcoming cricket matches
 * @returns {Promise<Array>} - Array of upcoming matches
 */
export const getUpcomingMatches = async () => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 500));
  
  // Return upcoming matches from all categories
  return [
    ...IPL_MATCHES.filter(match => !match.status || match.status !== 'Live'),
    ...ODI_MATCHES.filter(match => !match.status || match.status !== 'Live'),
    ...TEST_MATCHES.filter(match => !match.status || match.status !== 'Live')
  ];
};

/**
 * Get all matches by type
 * @param {string} matchType - The match type (IPL, ODI, TEST)
 * @returns {Promise<Array>} - Array of matches of the specified type
 */
export const getMatchesByType = async (matchType) => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 500));
  
  switch(matchType) {
    case 'IPL':
      return IPL_MATCHES;
    case 'ODI':
      return ODI_MATCHES;
    case 'TEST':
      return TEST_MATCHES;
    default:
      return [...IPL_MATCHES, ...ODI_MATCHES, ...TEST_MATCHES];
  }
};

/**
 * Get match details by match ID
 * @param {string} matchId - The match ID
 * @returns {Promise<Object>} - Match details
 */
export const getMatchDetails = async (matchId) => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 500));
  
  // Find match in any of the match types
  const match = [...IPL_MATCHES, ...ODI_MATCHES, ...TEST_MATCHES].find(m => m.id === matchId);
  
  if (!match) {
    throw new Error(`Match with ID ${matchId} not found`);
  }
  
  return {
    ...match,
    details: {
      format: match.matchType,
      tournament: match.matchType === 'IPL' ? 'Indian Premier League' : 
                 match.matchType === 'ODI' ? 'One Day International' : 'Test Series',
      location: match.venue,
      umpires: ['Richard Kettleborough', 'Kumar Dharmasena'],
      referee: 'Ranjan Madugalle'
    }
  };
};

/**
 * Get match scorecard by match ID
 * @param {string} matchId - The match ID
 * @returns {Promise<Object>} - Match scorecard
 */
export const getMatchScorecard = async (matchId) => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 500));
  
  // Only provide scorecard for current matches
  const liveMatches = [...IPL_MATCHES, ...ODI_MATCHES, ...TEST_MATCHES].filter(match => match.status === 'Live');
  const match = liveMatches.find(m => m.id === matchId);
  
  if (!match) {
    throw new Error(`Scorecard for match ID ${matchId} not found`);
  }
  
  return {
    ...match,
    scorecard: {
      // Mock scorecard data
      innings: [
        {
          team: match.teams[0],
          score: match.score.team1,
          overs: '20',
          batsmen: [
            { name: 'Player 1', runs: 45, balls: 38 },
            { name: 'Player 2', runs: 62, balls: 43 }
          ]
        },
        {
          team: match.teams[1],
          score: match.score.team2,
          overs: '15.2',
          batsmen: [
            { name: 'Player 3', runs: 30, balls: 25 },
            { name: 'Player 4', runs: 48, balls: 32 }
          ]
        }
      ]
    }
  };
}; 